import DocumentLink from './DocumentLink';

export default DocumentLink;
